import { createActionsHook } from 'src/lib/sweetState';

import { VisualLanguageStore } from './VisualLanguageStore';

export const useVisualLanguageActions = createActionsHook(VisualLanguageStore);
